/** @jsxImportSource @emotion/react */

import { Tabs, TabsProps } from "antd";
import _map from "lodash/map";
import { useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import DepositTable from "./DepositTable";
// import Nodata from "./Nodata";
import RebateTable from "./RebateTable";
import { TransactionTabsStyle } from "./style.index";
import WithdrawTable from "./WithdrawTable";

enum TransactionTabItem {
  DEPOSIT = "deposit",
  WITHDRAW = "withdraw",
  REBATE = "rebate",
}

const tabItems: TabsProps["items"] = _map(
  [
    {
      key: TransactionTabItem.DEPOSIT,
      label: "Nạp tiền",
      children: <DepositTable />,
    },
    {
      key: TransactionTabItem.WITHDRAW,
      label: "Rút tiền",
      children: <WithdrawTable />,
    },
    {
      key: TransactionTabItem.REBATE,
      label: "Chuyển tiền",
      children: <RebateTable />,
    },
    // {
    //   key: "4",
    //   label: "Công ty gửi tiền",
    //   children: <Nodata />,
    // },
    // {
    //   key: "5",
    //   label: "Thanh toán trực tiếp",
    //   children: <Nodata />,
    // },
    // {
    //   key: "6",
    //   label: "Rút tiền trực tiếp",
    //   children: <Nodata />,
    // },
    // {
    //   key: "7",
    //   label: "Nạp rút thủ công",
    //   children: <Nodata />,
    // },
    // {
    //   key: "8",
    //   label: "Hoạt động ưu đãi",
    //   children: <Nodata />,
    // },
    // {
    //   key: "9",
    //   label: "Hoàn trả",
    //   children: <Nodata />,
    // },
    // {
    //   key: "10",
    //   label: "Hoàn trả ngày",
    //   children: <Nodata />,
    // },
    // {
    //   key: "11",
    //   label: "VIP bonus",
    //   children: <Nodata />,
    // },
    // {
    //   key: "12",
    //   label: "Khác",
    //   children: <Nodata />,
    // },
  ],
  (item) => {
    return {
      ...item,
      label: <span data-comp="tab-label">{item.label}</span>,
    };
  },
);

const TransactionTabs = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const activeTab = useMemo(() => {
    return searchParams.get("tab") || TransactionTabItem.DEPOSIT;
  }, [searchParams]);

  const onChange = (key: string) => {
    setSearchParams({
      tab: key,
    });
  };

  useEffect(() => {
    setSearchParams({
      tab: searchParams.get("tab") || TransactionTabItem.DEPOSIT,
    });
  }, []);

  return (
    <div css={TransactionTabsStyle.wrapper}>
      <Tabs
        size="small"
        activeKey={activeTab}
        items={tabItems}
        onChange={onChange}
        destroyInactiveTabPane
      />
    </div>
  );
};

export default TransactionTabs;
